export const PRIMARY_REPAIR_AGENT = {
    PSGRP : 'PSGRP'
};
export const SECONDARY_REPAIR_AGENT = {
    SSGRP1:'SSGR1',
    SSGRP2:'SSGR2'
}